import NzRollReturnsSerializer from './base';

export default class ReturnDate extends NzRollReturnsSerializer {}
